import { Typography } from '@material-ui/core';
import axios from 'axios';
import * as d3 from 'd3';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import usMap, { arrangeLabels } from '../modules/maps';
import colors from '../modules/colors';

export default function MapUS({ width, height }) {
  const [includedStates, setIncludedStates] = useState([]);
  const [, setReady] = useState(false);
  const [error, setError] = useState(null);
  const svgRef = useRef(null);

  useEffect(() => {
    // setIncludedStates(['Minnesota', 'Wisconsin', 'Illinois', 'Massachusetts', 'Oregon', 'Washington']);
    axios.get(`${process.env.REACT_APP_RDS_URL}/ccdc/provider/tabulate?dims=submission_state&measure=COUNT:COUNT(*)&inject=true&metadata=false&orderBy=submission_state%20ASC&totals=true`)
      .then((response) => {
        // console.log(response);
        const states = response.data.records.map((r) => (r[0]));
        setIncludedStates(states);
      }).catch((getError) => {
        setError(getError);
      })
      .finally(() => {
        setReady(true);
      });
  }, []);

  useEffect(() => {
    setError(null);
    // console.log(`width: ${width}, height: ${height}`);
    async function renderMap() {
      const svg = d3.select(svgRef.current)
        .attr('width', width)
        .attr('height', height)
        .html(null); // clear svg for re-render on resize

      // const widthScale = d3.scaleLinear()
      //   .domain([width, 0]) // container div width
      //   .range([width, 0]); // scaled width

      // // D3 Projection
      // const projection = d3.geoAlbersUsa()
      //   .translate([width / 2, height / 2]) // translate to center of screen
      //   .scale([widthScale(width)]); // scale things down so see entire US

      const projection = d3.geoAlbersUsa().fitSize([width, height], usMap);

      // Define path generator
      const path = d3.geoPath() // path generator that will convert GeoJSON to SVG paths
        .projection(projection); // tell path generator to use albersUsa projection

      function handleMouseOver(d) {
        d3.select(this).attr('cursor', 'pointer');
      }

      function handleClick(d) {
        window.location.href = `${process.env.REACT_APP_ROOT_PATH}/state/${d.properties.id.replace('US-', '').toLowerCase()}`;
      }

      svg
        // .attr('preserveAspectRatio', 'xMinYMin meet')
        // .attr('viewBox', `0 0 ${height} ${width}`)
        // .classed('svg-content-responsive', true)
        .append('g')
        .style('overflow', 'visible')
        .attr('class', 'states')
        .selectAll('path')
        .data(usMap.features)
        .enter()
        .append('path')
        .attr('d', path)
        .style('fill', (d) => {
          if (includedStates.includes(d.properties.name)) {
            return colors.blue;
          }
          return colors.grey;
        })
        .style('stroke-width', '1')
        .style('stroke', '#fff')
        .on('mouseover', handleMouseOver)
        .on('click', handleClick);

      svg.append('g')
        .selectAll('text')
        .data(usMap.features)
        .enter()
        .append('text')
        .attr('class', 'map-label')
        .style('fill', (d) => {
          // console.log(d.properties)
          return includedStates.includes(d.properties.name) ? colors.white : colors.black;
        })
        .text((d) => {
          if (width < 960) {
            return d.properties.id.replace('US-', '');
          }
          return d.properties.name;
        })
        .attr('x', (d) => path.centroid(d)[0])
        .attr('y', (d) => path.centroid(d)[1])
        .attr('text-anchor', 'middle')
        .attr('font-size', (d) => {
          if (width < 600) {
            return 'x-small';
          }
          if (width < 960) {
            return 'smaller';
          }
          return '14';
        })
        .on('mouseover', handleMouseOver)
        .on('click', handleClick);

      arrangeLabels(svg);
    }

    renderMap();
  }, [width, height, includedStates]);

  return (
    <>
      {error && <Typography align="center" variant="body1" color="error">Error retrieving states&apos; data: {error.message}</Typography>}
      <svg ref={svgRef} />
    </>
  );
}

MapUS.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

MapUS.defaultProps = {
  width: 800,
  height: 600,
};
